import { routes } from 'constant/routes';
import { useQuery } from 'hooks';
import React, { ComponentType, FC, useEffect } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';
import { StorageKeys } from 'services';
import { actions, selectors, useAppDispatch, useAppSelector } from 'store';

type SignInRouteType = FC<{ component: ComponentType } & RouteProps>;

const SignInRoute: SignInRouteType = ({ component: Component }) => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector(selectors.auth.selectAccessToken);
  const query = useQuery();

  const courseId = query.get(StorageKeys.COURSE_ID);
  const isLandingPage = query.get('isLandingPage');
  const impersonationToken = query.get('impersonationToken');

  const landingCourseId = query.get('courseId');

  useEffect(() => {
    dispatch(actions.auth.setIsLandingPage(isLandingPage));
  }, [dispatch, isLandingPage]);

  const isImpersonationPending = Boolean(impersonationToken) && impersonationToken !== accessToken;

  useEffect(() => {
    if (isImpersonationPending && impersonationToken) {
      dispatch(actions.auth.setIsAuthenticated(impersonationToken));
    }
  }, [dispatch, impersonationToken, isImpersonationPending]);

  if (isImpersonationPending && impersonationToken) {
    return null;
  }

  const subscribeType = query.get(StorageKeys.SUBSCRIBE_TYPE);
  const term = query.get(StorageKeys.TERM_PERIOD);

  const isQuery = courseId && subscribeType && term;

  const paymentQuery = isQuery
    ? `?${StorageKeys.COURSE_ID}=${courseId}&${StorageKeys.SUBSCRIBE_TYPE}=${subscribeType}&${StorageKeys.TERM_PERIOD}=${term}`
    : isLandingPage
    ? `?isLandingPage=${isLandingPage}&landingCourseId=${landingCourseId}`
    : '';

  return accessToken ? <Navigate to={{ pathname: routes.home, search: paymentQuery }} replace /> : <Component />;
};

export default SignInRoute;
